export default "__VITE_ASSET__BNlTBiko__"